module.exports = __webpack_public_path__ + "static/media/135U3_Bedroom.645c382c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U3_Bedroom.jpg
// module id = 540
// module chunks = 0